import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { App } from './App.js';
import { captureAuthHash } from './lib/auth.js';
import { applyTheme, readTheme } from './lib/theme.js';
import './index.css';

applyTheme(readTheme());
captureAuthHash();

const root = document.getElementById('root');
if (!root) throw new Error('The #root element is missing from index.html.');

createRoot(root).render(
  <StrictMode>
    <App />
    <Toaster
      position="bottom-center"
      toastOptions={{
        style: {
          background: 'var(--color-surface)',
          color: 'var(--color-ink)',
          border: '1px solid var(--color-line)',
          boxShadow: 'var(--shadow-sm)',
        },
      }}
    />
  </StrictMode>,
);
